import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { SvcIssueRequestAttachmentContainerModel } from '../../../../../models/aggregates/svc-issue-request-attachment';
import { Observable } from 'rxjs';
import { BasicApiResponseModel, ApiResponseModel } from '../shared/api-response.model';
import { ApiVisa } from '../shared';
import { BaseApiPublicLoginTemplateService } from '../shared/base-api-public-login-template.service';
import { FilesDetailsRequest } from '../../../../../models/file-image';

@Injectable({
  providedIn: 'root'
})
export class SvcIssueRequestAttachmentService extends BaseApiPublicLoginTemplateService<SvcIssueRequestAttachmentContainerModel,SvcIssueRequestAttachmentContainerModel,SvcIssueRequestAttachmentContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'svc/issue-request-attachments/' + BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'svc/issue-request-attachments/' + BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path_login_entity_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'svc/issue-request-attachments/' + BaseApiTemplateService.LOGIN_ENTITY_EP;
    this.endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'svc/issue-request-attachments/' + BaseApiTemplateService.PUBLIC_EP;
    this.httpClient = http;
  }
  
  public addAttachmentsLoginEntity(svcNoteIssueRequestHdrGuid: string, files: File[], visa: ApiVisa, filesDetails?: FilesDetailsRequest): Observable<BasicApiResponseModel<SvcIssueRequestAttachmentContainerModel>> {
    if (visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'svc/issue-request-attachments/' + BaseApiTemplateService.LOGIN_ENTITY_EP;
    }

    const formData: FormData = new FormData();
    files.forEach(file => {
      console.log('each file', file);
      formData.append('file', file)
    });
    
    if (filesDetails) {
      formData.set(
      'files-data',
      new Blob([JSON.stringify(filesDetails)], { type: 'application/json' }),
      'files-data.json')
    }

    return this.httpClient.post<BasicApiResponseModel<SvcIssueRequestAttachmentContainerModel>>(
      this.apiUrl + '/' + svcNoteIssueRequestHdrGuid,
      formData,
      this.getHttpHeader(visa)
    );
  }
  
}